import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/prediction-welcome';
const req = require.context('!raw-loader!../../../markdowns/prediction-welcome', false, /\.(md|jsx)$/);

export default function Welcome() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
